import React from "react";
export const ScreenWidthContext = React.createContext('desktop');